import React from "react";
import PolicyLayout from "../Policy/PolicyLayout";

const Usage = () => {
  const sections = [
    {
      id: "account",
      title: "Account Registration",
      body:
        "All accounts must be registered using the full legal name of the user to avoid potential rejection of requests or services.",
    },
    {
      id: "vouchers",
      title: "Usage of E-Vouchers and Gift Cards",
      body:
        "E-vouchers and gift cards are one-time-use only. Codes are case-sensitive and must be entered exactly as displayed on your delivery email.",
    },
    {
      id: "refund-limit",
      title: "Refund and Exchange Limitations",
      body:
        "E-vouchers, gift cards, prepaid cards, or any digital products delivered via GlobalGiftPass.io are non-refundable and non-exchangeable once reviewed, delivered, or redeemed.",
    },
    {
      id: "responsibility",
      title: "User Responsibility",
      body: (
        <p>
          <b>GlobalGiftPass.io</b> and its affiliates are not liable for
          incorrect purchases caused by user negligence, such as providing
          inaccurate or fake information. By purchasing any e-voucher or gift
          card, users acknowledge and accept this disclaimer.
        </p>
      ),
    },
    {
      id: "shipping",
      title: "Direct Credit Shipping",
      body:
        "Users must carefully review product descriptions to confirm the accuracy of purchases before completing transactions.",
    },
    {
      id: "redemption",
      title: "Redemption Process & Balance Adjustment",
      body:
        "If the redemption value exceeds the available balance, GlobalGiftPass.io reserves the right to settle the remaining balance directly from the user's account.",
    },
    {
      id: "post-delivery",
      title: "Post-Delivery Liability",
      body: [
        "Once delivered, GlobalGiftPass.io is not liable for any loss or damage to purchased electronic goods. Invalid vouchers will not be refunded if the claim is made more than 15 days after purchase.",
        "For the avoidance of doubt, any gift card or voucher delivered to the customer's registered email address shall be considered fulfilled and completed, regardless of whether the email is accessed or the code is redeemed.",
      ],
    },
    {
      id: "loyalty",
      title: "Loyalty Program",
      body: (
        <>
          <p>Points earned through loyalty programs have the following validity:</p>
          <ul>
            <li><b>Regular points:</b> valid for 3 months from the date of crediting</li>
            <li><b>Prize points:</b> valid for 2 weeks unless otherwise stated</li>
          </ul>
          <p>
            Unused points will be automatically deducted after expiration.
            GlobalGiftPass.io reserves the right to modify or cancel the
            loyalty program at any time without prior notice, forfeit unredeemed
            points upon termination, and suspend accounts where fraudulent
            activity, misuse or violations are detected.
          </p>
        </>
      ),
    },
    {
      id: "disputes",
      title: "Order Execution & Disputes",
      body:
        "Orders with incorrect or suspicious details may be rejected, and funds will be returned to the source account. Memberships associated with fraudulent or suspicious activity will be suspended, and all details may be forwarded to the Department of Cybercrime for legal action.",
    },
    {
      id: "refund-time",
      title: "Refund Timelines",
      body:
        "Refunds for unprocessed requests may take up to 3 weeks to be returned to the originating account.",
    },
    {
      id: "communication",
      title: "Communication",
      body:
        "By registering on GlobalGiftPass.io, users consent to receiving promotional offers, discounts and product updates via email. You may opt out of marketing communications at any time.",
    },
    {
      id: "buy-and-win",
      title: "Buy and Win Section",
      body:
        "Winners of raffle promotions must publicly acknowledge their win on personal social media accounts to maintain transparency and credibility.",
    },
    {
      id: "bank",
      title: "Bank Transfers",
      body:
        "Refunds for bank transfer requests do not cover commissions or transfer fees. Transfers from multiple bank accounts will not be processed.",
    },
    {
      id: "approval",
      title: "Order Approval",
      body:
        "Orders may be rejected for various reasons, including unavailability, pricing errors, or suspected fraud. Refunds will be provided for canceled or unapproved orders. Additional information, such as identity verification, may be requested before processing.",
    },
    {
      id: "promo",
      title: "Gifts & Promotional Codes",
      body:
        "Gifts or promotional codes provided as rewards are valid for 3 days unless otherwise specified.",
    },
    {
      id: "discounts",
      title: "Discounts and Points",
      body:
        "Purchases using discount coupons will not earn loyalty points.",
    },
    {
      id: "amendments",
      title: "Amendments and Modifications",
      body:
        "GlobalGiftPass.io reserves the right to modify its Website, applications, policies or agreements at any time without prior notice. Continued use of the platform constitutes acceptance of such changes.",
    },
    {
      id: "contact",
      title: "Contact Information",
      body: (
        <>
          <p>For further inquiries, please contact us at:</p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:support@globalgiftpass.io">support@globalgiftpass.io</a>
            </li>
            <li>VentureWorks Dynamics LLC, Sharjah Media City, Sharjah, UAE</li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <PolicyLayout
      slug="shipping"
      eyebrow="USAGE POLICY"
      title="How to use our"
      accent="services"
      sub="The terms governing the use of GlobalGiftPass.io services — e-vouchers, gift cards, accounts, loyalty and more."
      lastUpdated="January 2026"
      intro={
        <p>
          This Usage Policy outlines the terms and conditions governing the use
          of GlobalGiftPass.io services, including e-vouchers, gift cards, and
          other digital products. By using the Website, you agree to abide by
          the rules set out below.
        </p>
      }
      notice="Codes are one-time-use and case-sensitive. Once delivered to your registered email, the gift card is considered fulfilled."
      sections={sections}
    />
  );
};

export default Usage;
